import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvMagellanTrainingService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      _env: 'magellan-training',
      _apiUrl: 'https://training2-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://training2-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://magellantrainingadb2c.b2clogin.com/df19c6a6-0bd9-46a3-9145-b0b288e0cdeb/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://magellantrainingadb2c.b2clogin.com.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '2bcd473c-134a-4ef2-8049-032826ebc4d3',
      _scope:
        'openid profile https://magellantrainingadb2c.onmicrosoft.com/api/magellan.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://training2-login.p-cis.com/',
      _signInURL:
        "https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp",
      _signInURLSSO:
        "https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO",
      _adb2cTenantUrl:
        'https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink:
        'https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://magellantrainingadb2c.b2clogin.com/magellantrainingadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
